<template>
	<v-container fluid class="pa-0">
		<grid-table-deleted
			v-if="deletedEntriesModal"
			:showDialog="deletedEntriesModal"
			:defaultGridView="defaultGridView"
			@close="onDeletedDataModalClose"
		/>
		<manage-fields-dialog
			v-if="manageFieldsDialog"
			:showDialog="manageFieldsDialog"
			:hiddenColumns="hiddenColumns"
			:visibleColumns="visibleColumns"
			@close="onManageFieldsDialogClosed"
			@save="onManageFieldsDialogUpdate"
		/>
		<save-view-dialog
			v-if="saveViewDialog"
			:saveViewStoreAction="saveViewAction"
			:showDialog="saveViewDialog"
			:globalViewPermission="globalViewPermission"
			@close="onSaveViewDialogClose"
		/>
		<manage-views-dialog
			v-if="manageViewsDialog"
			:showDialog="manageViewsDialog"
			:viewsList="userGridViews"
			:deleteViewAction="deleteViewAction"
			:setDefaultViewAction="setDefaultViewAction"
			:setGlobalViewAction="setGlobalViewAction"
			:globalViewPermission="globalViewPermission"
			@close="onManageViewsClose"
		/>
		<!-- normal toolbar -->
		<v-row class="grid-toolbar d-none d-sm-flex" no-gutters>
			<v-col class="flex-grow-0 flex-shrink-0">
				<v-menu
					order="2"
					content-class="grid-toolbar-menu"
					:close-on-content-click="closeOnContent"
					offset-y
				>
					<template #activator="{ on, attrs, value }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							class="settings-menu-btn"
							color="primary"
						>
							<v-icon>mdi-cog</v-icon>
							<v-icon v-if="value">mdi-menu-up</v-icon>
							<v-icon v-else>mdi-menu-down</v-icon>
						</v-btn>
					</template>
					<v-list>
						<template v-for="(item, i) in menuItems">
							<item-group
								v-if="item.children"
								:key="`grid-group-${i}`"
								:item="item"
								@groupClick="onGroupClick()"
								@itemClick="onItemClick()"
							/>
							<export-modal
								v-else-if="item.isExportModal"
								:key="`grid-export-${i}`"
								:show-time-zone-options="true"
								:show-execution-options="true"
								:show-data-scope-options="true"
								:show-visible-data-option="true"
								:show-all-data-option="true"
								:default-utc-time="false"
								:default-background-export="false"
								@export="onExportModalEvent"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-list-item
										v-bind="attrs"
										v-on="on"
										@click="onItemClick()"
									>
										<v-list-item-content>
											<v-list-item-title>
												<v-icon small left
													>mdi-cloud-download</v-icon
												>
												{{ item.title }}
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
							</export-modal>
							<list-item
								@click="onItemClick()"
								v-else
								:key="`grid-item-${i}`"
								:item="item"
							/>
						</template>
					</v-list>
				</v-menu>
			</v-col>
			<v-col cols="2" class="flex-grow-0 flex-shrink-0 d-flex">
				<div class="view-title">
					{{ gridViewName }}
				</div>
			</v-col>
			<v-col class="flex-grow-1 flex-shrink-1">
				<quick-filter
					:Columns="visibleColumns"
					:filter="quickFilter"
					@filterChanged="onQuickFilterChanged"
				/>
			</v-col>
			<v-col class="flex-grow-0 flex-shrink-0 d-none d-lg-flex">
				<v-badge
					:value="advancedFilter.FiltersCount > 0"
					left
					class="d-none d-lg-flex"
					bordered
					overlap
				>
					<template v-slot:badge>
						<span style="color: white">{{
							advancedFilter.FiltersCount
						}}</span>
					</template>
					<v-btn color="primary" @click="onShowAdvancedFilter">
						<v-icon class="mr-1">mdi-magnify</v-icon>
						Advanced search
					</v-btn>
				</v-badge>
			</v-col>
			<v-col class="flex-grow-0 flex-shrink-0 d-none d-lg-flex ml-2">
				<export-modal
					:show-time-zone-options="true"
					:show-execution-options="true"
					:show-data-scope-options="true"
					:show-visible-data-option="true"
					:show-all-data-option="true"
					:default-utc-time="false"
					:default-background-export="false"
					button-text="Export"
					color="primary"
					icon="mdi-cloud-download"
					@export="onExportModalEvent"
				>
					<!-- Use default slot content (no custom activator needed for desktop) -->
				</export-modal>
			</v-col>
			<v-col class="flex-grow-0 flex-shrink-0 d-lg-none">
				<v-menu
					offset-y
					:close-on-content-click="false"
					v-model="dotsMenuOpen"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							class="d-lg-none"
							color="primary"
						>
							<v-icon>mdi-dots-vertical</v-icon>
						</v-btn>
					</template>
					<v-list class="d-lg-none">
						<v-list-item @click="onAdvancedSearchFromDots">
							<v-list-item-content>
								<v-list-item-title>
									<v-icon small left>mdi-magnify</v-icon>
									Advanced search
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<export-modal
							:show-time-zone-options="true"
							:show-execution-options="true"
							:show-data-scope-options="true"
							:show-visible-data-option="true"
							:show-all-data-option="true"
							:default-utc-time="false"
							:default-background-export="false"
							@export="onExportModalEventFromDots"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-list-item v-bind="attrs" v-on="on">
									<v-list-item-content>
										<v-list-item-title>
											<v-icon small left
												>mdi-cloud-download</v-icon
											>
											Export
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</template>
						</export-modal>
					</v-list>
				</v-menu>
			</v-col>
		</v-row>
		<!-- normal toolbar -->
		<!-- responsive toolbar -->
		<v-row class="grid-toolbar d-sm-none" no-gutters>
			<v-col class="flex-grow-0 flex-shrink-0">
				<v-menu
					order="2"
					content-class="grid-toolbar-menu"
					:close-on-content-click="closeOnContent"
					offset-y
				>
					<template #activator="{ on, attrs, value }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							class="settings-menu-btn"
							color="primary"
						>
							<v-icon>mdi-cog</v-icon>
							<v-icon v-if="value">mdi-menu-up</v-icon>
							<v-icon v-else>mdi-menu-down</v-icon>
						</v-btn>
					</template>
					<v-list>
						<template v-for="(item, i) in menuItems">
							<item-group
								v-if="item.children"
								:key="`grid-group-${i}`"
								:item="item"
								@groupClick="onGroupClick()"
								@itemClick="onItemClick()"
							/>
							<export-modal
								v-else-if="item.isExportModal"
								:key="`grid-export-${i}`"
								:show-time-zone-options="true"
								:show-execution-options="true"
								:show-data-scope-options="true"
								:show-visible-data-option="true"
								:show-all-data-option="true"
								:default-utc-time="false"
								:default-background-export="false"
								@export="onExportModalEvent"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-list-item
										v-bind="attrs"
										v-on="on"
										@click="onItemClick()"
									>
										<v-list-item-content>
											<v-list-item-title>
												<v-icon small left
													>mdi-cloud-download</v-icon
												>
												{{ item.title }}
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
							</export-modal>
							<list-item
								@click="onItemClick()"
								v-else
								:key="`grid-item-${i}`"
								:item="item"
							/>
						</template>
					</v-list>
				</v-menu>
			</v-col>
			<v-col class="flex-grow-1 flex-shrink-1 view-title">
				{{ gridViewName }}
			</v-col>
		</v-row>
		<v-row class="grid-toolbar d-sm-none" no-gutters>
			<v-col class="flex-grow-1 flex-shrink-0">
				<quick-filter
					:Columns="visibleColumns"
					:filter="quickFilter"
					@filterChanged="onQuickFilterChanged"
				/>
			</v-col>
		</v-row>
		<!-- responsive toolbar -->
		<filters-dialog
			v-if="showAdvancedFilter"
			:dialog="showAdvancedFilter"
			:filter="advancedFilter"
			:columns="visibleColumns"
			@filterChanged="onAdvancedFilterChanged"
		/>
	</v-container>
</template>
<script>
import QuickFilter from '../../shared/gridViews/QuickFilter.vue';
import FiltersDialog from '../../shared/gridViews/FiltersDialog';
import ManageFieldsDialog from '../../shared/gridViews/ManageFieldsDialog.vue';
import SaveViewDialog from '../../shared/gridViews/SaveViewDialog.vue';
import ManageViewsDialog from '../../shared/gridViews/ManageViewsDialog.vue';
import GridTableDeleted from './GridTableDeleted.vue';
import ExportModal from '../../shared/export/ExportModal.vue';
import { Permissions } from '../../../enums/permissionsEnum';
import ItemGroup from '@/components/base/ItemGroup';
import ListItem from '@/components/base/ListItem';
import permissionsMixin from '../../../mixins/permissionsMixin';
import gridViewOwnerMixin from '../../../mixins/grids/gridViewOwnerMixin';
import { GridsPageActions } from '../../../store/actions';
import { GridsPageGetters } from '../../../store/getters';
import { mapGetters } from 'vuex';
import { routesNames } from '../../../enums/routesNames';

export default {
	name: 'GridToolbar',
	mixins: [permissionsMixin, gridViewOwnerMixin],
	props: {
		gridViewName: String,
		quickFilter: Object,
		advancedFilter: Object,
		visibleColumns: Array,
		hiddenColumns: Array,
	},
	components: {
		GridTableDeleted,
		QuickFilter,
		FiltersDialog,
		ManageFieldsDialog,
		SaveViewDialog,
		ListItem,
		ItemGroup,
		ManageViewsDialog,
		ExportModal,
	},
	data() {
		return {
			deletedEntriesModal: false,
			closeOnContent: true,
			saveViewDialog: false,
			manageViewsDialog: false,
			manageFieldsDialog: false,
			saveViewAction: GridsPageActions.SAVE_GRID_VIEW,
			deleteViewAction: GridsPageActions.DELETE_GRID_VIEW,
			setDefaultViewAction: GridsPageActions.SET_DEFAULT_GRID_VIEW,
			setGlobalViewAction: GridsPageActions.SET_GLOBAL_GRID_VIEW,
			globalViewPermission: Permissions.Grids.CreateGlobalGridView,
			showAdvancedFilter: false,
			multipleSelectionToggle: false,
			dotsMenuOpen: false,
		};
	},
	computed: {
		...mapGetters({
			userGridViews: [GridsPageGetters.USER_GRIDS_VIEWS],
			gridView: [GridsPageGetters.GRID_VIEW],
			defaultGridView: [GridsPageGetters.DEFAULT_GRID_VIEW],
		}),
		canAdd() {
			return this.hasPermissions([Permissions.Grids.Add]);
		},
		canViewDeleted() {
			return this.hasPermissions([Permissions.Grids.ViewDeletedEntries]);
		},
		canBulkEdit() {
			return this.hasPermissions([Permissions.Grids.BulkEdit]);
		},
		canMerge() {
			return this.hasPermissions([Permissions.Grids.Merge]);
		},
		menuItems() {
			let result = [];

			// Always available items
			result.push({
				title: 'Save view as new',
				clickHandler: () => this.saveView(),
			});
			result.push({
				title: 'Manage views',
				clickHandler: () => this.manageViews(),
			});
			result.push({
				title: 'View History',
				clickHandler: () => this.onViewHistory(),
			});
			result.push({
				title: 'Views',
				children: this.viewsList,
			});

			// Conditional items based on user permissions and grid view type
			// a global view belongs to whoever created it, the others cannot reshape it
			if (this.isViewOwner(this.gridView) || this.gridView.Type != 1) {
				result.push({
					title: 'Update current view',
					clickHandler: () => this.updateView(),
				});
				result.push({
					title: 'Manage fields',
					clickHandler: () => this.manageFields(),
				});
			}

			if (this.canAdd) {
				result.push({
					title: 'Create new',
					clickHandler: () =>
						this.$router.push(`${this.gridView.Entity.Name}/add`),
				});
			}

			if (this.canViewDeleted) {
				result.push({
					title: 'Deleted data',
					clickHandler: () => this.manageDeletedData(),
				});
			}

			if (this.canBulkEdit) {
				result.push({
					title: 'Multiple Selection',
					clickHandler: () => this.onMultipleSelectionClick(),
				});
			}

			if (this.multipleSelectionToggle) {
				result.push({
					title: 'Bulk Edit',
					clickHandler: () => this.onBulkEditClick(),
				});
				result.push({
					title: 'Bulk Delete',
					clickHandler: () => this.onBulkDeleteClick(),
				});
				if (this.canMerge) {
					result.push({
						title: 'Merge',
						clickHandler: () => this.onMergeClick(),
					});
				}
			}

			// Sort all items alphabetically by title
			return result.sort((a, b) => a.title.localeCompare(b.title));
		},

		viewsList() {
			return this.userGridViews.map((view) => {
				return {
					...view,
					title: view.Name,
					clickHandler: () => this.openView(view),
				};
			});
		},
	},
	methods: {
		onDeletedDataModalClose() {
			this.deletedEntriesModal = false;
			this.$store.dispatch(
				GridsPageActions.LOAD_GRID_VIEW,
				this.gridView
			);
		},
		onShowAdvancedFilter() {
			this.showAdvancedFilter = true;
		},
		onExportModalEvent(exportConfig) {
			// exportConfig contains: { timeZone, isBackgroundExport, allData }
			const action = exportConfig.allData
				? GridsPageActions.EXPORT_ALL_DATA
				: GridsPageActions.EXPORT_CURRENT_GW_PAGE;

			const actionParams = {
				timeZone: exportConfig.timeZone,
				isDirectMode: !exportConfig.isBackgroundExport,
			};

			this.$store.dispatch(action, actionParams);
		},
		onGroupClick() {
			this.closeOnContent = false;
		},
		onItemClick() {
			this.closeOnContent = true;
		},
		onManageViewsClose() {
			this.manageViewsDialog = false;
		},
		updateView() {
			this.$store.dispatch(
				GridsPageActions.UPDATE_GRID_VIEW,
				this.gridView.Id
			);
		},
		saveView() {
			this.saveViewDialog = true;
		},
		onSaveViewDialogClose() {
			this.saveViewDialog = false;
		},
		manageViews() {
			this.manageViewsDialog = true;
		},
		onMultipleSelectionClick() {
			this.multipleSelectionToggle = !this.multipleSelectionToggle;
			this.$emit('multipleSelectionClick', this.multipleSelectionToggle);
		},
		onBulkEditClick() {
			this.$emit('bulkEdit');
		},
		onBulkDeleteClick() {
			this.$emit('bulkDelete');
		},
		onMergeClick() {
			this.$emit('mergeEntities');
		},
		manageFields() {
			this.manageFieldsDialog = true;
		},
		manageDeletedData() {
			this.deletedEntriesModal = true;
		},
		onManageFieldsDialogClosed() {
			this.manageFieldsDialog = false;
		},
		onViewHistory() {
			this.$router.push({
				name: routesNames.DATASETS_HISTORY,
				params: this.$route.params,
			});
		},

		onManageFieldsDialogUpdate(value) {
			this.$store
				.dispatch(GridsPageActions.UPDATE_GRID_VIEW_FIELDS, value)
				.then((success) => {
					if (!success) return;
					this.manageFieldsDialog = false;
				});
		},

		openView(view) {
			this.$store.dispatch(GridsPageActions.LOAD_GRID_VIEW, view);
		},
		onQuickFilterChanged(value) {
			this.$emit('quickFilterChanged', value);
		},
		onAdvancedFilterChanged(value) {
			this.$emit('advancedFilterChanged', value);
			this.showAdvancedFilter = false;
		},
		onAdvancedSearchFromDots() {
			this.dotsMenuOpen = false;
			this.showAdvancedFilter = true;
		},
		onExportModalEventFromDots(exportConfig) {
			this.dotsMenuOpen = false;
			this.onExportModalEvent(exportConfig);
		},
	},
};
</script>

<style lang="scss">
.grid-toolbar-menu .v-list-group {
	border-top: 1px solid #eee;
	border-bottom: 1px solid #eee;
	.v-list-item__title {
		font-size: 14px;
	}
}
</style>
